import { getOrderReviewLocation, withLocale, USER_INFO_PATH } from '@/util/categoryRoute'

// 订单支付相关
const orderPayRouter = [
  {
    path: withLocale('/order'),
    component: () => import('@/layout/default.vue'),
    children: [
      {
        path: withLocale('/settlement'),
        name: 'SETTLEMENT',
        component: () => import('@/views/settlement/index.vue'),
        // component: () => import('@/views/settlement/oldCreatedOrder/index.vue'),
        meta: {
          cnName: '创建订单',
          enName: 'Settlement'
        }
      },
      {
        path: withLocale('/oldSettlement'),
        name: 'oldSettlement',
        component: () => import('@/views/settlement/index.vue'),
        meta: {
          cnName: '创建订单',
          enName: 'Settlement'
        }
      },
      {
        path: withLocale('/createOrder'),
        name: 'CREATEORDER',
        component: () => import('@/views/settlement/index.vue'),
        meta: {
          cnName: 'pricoo创建订单',
          enName: 'Settlement'
        }
      },

      {
        path: withLocale('/orderMain/:orderId'),
        name: 'ORDERMAIN',
        component: () => import('@/views/order/orderMain/index.vue'),
        meta: {
          cnName: '订单详情',
          enName: 'Order Detail'
        }
      },
      {
        path: withLocale('/order/review/orderId/:orderId'),
        name: 'ORDEREVALUATE',
        component: () => import('@/views/order/orderEvaluate/index.vue'),
        meta: {
          cnName: '已收货评论',
          enName: 'Received Comments'
        }
      },
      {
        path: withLocale('/order/review'),
        redirect: (to) => {
          const orderId = to.query.orderId
          if (!orderId) return { path: USER_INFO_PATH }
          const query = { ...to.query }
          delete query.orderId
          return { ...getOrderReviewLocation(orderId), query }
        }
      },
      {
        path: withLocale('/afterSale/:order'),
        name: 'AFTERSALE',
        component: () => import('@/views/order/afterSale.vue'),
        meta: {
          cnName: '售后服务',
          enName: 'After-sale Service'
        }
      },
      {
        path: withLocale('/successful'),
        name: 'successful',
        component: () => import('@/views/pay/successful/index.vue'),
        meta: {
          cnName: '支付成功',
          enName: 'Payment Successful'
        }
      },
      {
        path: withLocale('/other-payments'),
        name: 'OTHERPAYMENT',
        component: () => import('@/views/pay/other-payments.vue'),
        meta: {
          cnName: '其他支付方式',
          enName: 'Other Payments'
        }
      }
    ]
  }
]

export default orderPayRouter
